export default __webpack_public_path__ + "static/woods-icons-1dfe975213656390103a73b323c36b81.webp";